(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'subQualifications', {
            bindings: {
                qualifications:  '<',
                heading:         '<',
                content:         '<',
                autoCollapse:    '<'
            },
            templateUrl:  'app/views/partials/content/sub-qualifications.html',
            controller:   SubQualificationsController,
            controllerAs: 'vm',

            renderingOptions: {
                'nestedContent': {
                    inputs:    [
                        'qualifications="::content.asset_contents.qualifications"',
                        'heading="::content.asset_contents.heading"',
                        'content="::content.asset_contents.content"',
                        'auto-collapse=::content.asset_contents.autoCollapse'
                    ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes: [
                        'block-container',
                        'qualifications'
                    ]
                }
            }
        });


    /**
     * List with selectable sub-qualifications (programmes/subjects) blocks.
     *
     * @param {ng.IScope} $scope
     * @param {uirouter.State} $state
     * @param {Utils} Utils
     * @param {LoggerFactory} LoggerFactory
     * @param {SelectablesServiceany} SelectablesService
     * @param {SubpagesService} SubpagesService
     * @param {Object} TEXTS
     */
    function SubQualificationsController(
        $scope,
        $state,
        Utils,
        LoggerFactory,
        SelectablesService,
        SubpagesService,
        TEXTS
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @constant */
        var ITEMS                           = SelectablesService.ITEMS,
            POSTGRADS_SELECTABLE_ID         = 'postgradQuals',
            RESPONSE_ATTRIBUTE_INSIDE_PAGES = 'insidePages';


        /** @type {String} */
        var subpageContentId;


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'SubQualificationsController' );





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        /** @constant */
        $scope.ITEMS = ITEMS;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        /** @constructor */
        //vm.$onInit = function () {};


        /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
        Utils.addGenericPostLinkTrigger( vm );





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /** Uni-directional watchers */

        vm.$onChanges = function( changesObject ) {
            if ( changesObject.qualifications && changesObject.qualifications.currentValue ) {
                initModel();
                vm.$onChanges = function(){}; // Deregister event handler after quals are loaded
            }
        };


        function initModel() {
            SelectablesService.getSelectablesByIdPromise( POSTGRADS_SELECTABLE_ID ).then( function ( selectables ) {
                vm.qualsModel         = selectables.model;
                vm.selectablesConfig  = selectables.config;

                initQualificationsCollection();
            }).catch( function( err ) {
                logger.error( err );
            });
        }


        function initQualificationsCollection() {
            if ( !vm.qualifications || vm.qualifications.length < 0 ) {
                vm.qualsCollection = null;
                return;
            }

            /** @type {{ metadata: string, dynamicBlocks: Object[] }} */
            vm.qualsCollection = {};

            subpageContentId = SubpagesService.getCurrentSubpageContentId().replace( 'Blocks', '' ); // tab name
            

            vm.qualifications.forEach( function( singleQualification ) {
                var qualification = vm.qualsCollection[ singleQualification.metadata.id ] = {};

                qualification.metadata = singleQualification.metadata;
                qualification.dynamicBlocks = getQualsDynamicBlocks( singleQualification );
                // logger.warn (JSON.stringify(qualification)); // each qual found
            });

            // Prepare texts
            $scope._ = TEXTS.POSTGRAD.SELECTABLES[ SubpagesService.getSelectableAttribute().toUpperCase() ]; // parent md.selectability
            
            // logger.warn (SubpagesService.getSelectableAttribute().toUpperCase());

            vm.isSingleQual = vm.qualsModel[ ITEMS.ALL ].length === 1;
            vm.tester = true;

            bindMetadataIfRequired();
           
            if (vm.qualifications.length && vm.qualifications[0].metadata.hasOwnProperty('isSpecialisation') && vm.qualifications[0].metadata.isSpecialisation === "true" ) {
                vm.isSpecialisation = true;
            }
            else {
                vm.isSpecialisation = false;
            }
            // logger.warn(JSON.stringify(vm));

        }



        function getQualsDynamicBlocks( qualification ) {
            if ( qualification.hasOwnProperty( RESPONSE_ATTRIBUTE_INSIDE_PAGES ) && qualification[ RESPONSE_ATTRIBUTE_INSIDE_PAGES ].hasOwnProperty( subpageContentId ) ){
                return qualification[ RESPONSE_ATTRIBUTE_INSIDE_PAGES ][ subpageContentId ].asset_contents;
            } else {
                logger.warn( 'The sub-qualification `%s` seems to be using old or incorrect format! Please, update by moving all the content blocks under `references.qualifications[].%s.%s`', qualification.metadata.name, RESPONSE_ATTRIBUTE_INSIDE_PAGES, subpageContentId);

                return qualification.asset_contents;
            }
        }


        /**
         * If there's only a single qualification available, `nested-block`
         * component is not used and so `vm.metadata` have to this controller!
         */
        function bindMetadataIfRequired() {
            if ( vm.isSingleQual ) vm.metadata = vm.qualsModel[ ITEMS.ALL ][ 0 ].content.metadata;
        }
    };

    SubQualificationsController.$inject = [ '$scope', '$state', 'Utils', 'LoggerFactory', 'SelectablesService', 'SubpagesService', 'TEXTS', ];
})();
